import { createSlice } from "@reduxjs/toolkit";

const koreanProgramSlice = createSlice({
  name: "koreaProgram",
  initialState: {},
  reducers: {
    updateKoreanProgram(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateKoreanProgram } = koreanProgramSlice.actions;

export default koreanProgramSlice.reducer;
